import React from "react";
import { Button } from "@mui/material";
import { useNewBreadcrumb } from "recoils";
import { Label14Medium, ExportButton, useDialogControls } from "components";
import { PlusIcon } from "assets";
import { exportInitiatives } from "api";
import { useGetInitiatives } from "hooks";

import { INITIATIVES_PAGE } from "./consts";
import { CreateInitiativeModal, KpiSummaryCards, InitiativesTable } from "./components";

export const InitiativesPage = () => {
  useNewBreadcrumb(INITIATIVES_PAGE.TITLE);

  const { isOpen, open, close } = useDialogControls();
  const { data: initiatives } = useGetInitiatives();

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20, margin: "12px 24px", flex: 1, minHeight: 0 }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Label14Medium color="text.secondary">
            Track financial and emissions impact of decarbonization initiatives.
          </Label14Medium>
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <ExportButton
              exportFunction={exportInitiatives}
              exportText="Export Report"
              exportTitle="initiatives_export"
              isZipFile={false}
              fileExtension=".csv"
              disabled={!initiatives?.length}
              sx={{ height: "36px", width: "150px", borderRadius: 2 }}
            />
            <Button
              variant="contained"
              startIcon={<PlusIcon />}
              onClick={open}
              sx={{ height: "36px", width: "150px", borderRadius: 2 }}
            >
              Add Initiative
            </Button>
          </div>
        </div>
      </div>
      <KpiSummaryCards />
      <InitiativesTable />
      {isOpen && <CreateInitiativeModal isOpen={isOpen} onClose={close} />}
    </div>
  );
};
